import { plural, t } from '@lingui/core/macro';
import { NoddiButton, NoddiDialog } from 'noddi-ui-web';
import { useBookingCars } from 'noddi-web';
import { useState } from 'react';
import { getCarName } from '../../../utils/carName';
export const SelectedCars = () => {
  const selectedCars = useBookingCars();
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const numberOfSelectedCars = selectedCars.length;

  const carMessage = plural(numberOfSelectedCars, {
    one: 'Car',
    other: 'Cars'
  });

  if (numberOfSelectedCars === 0) {
    return null;
  }

  return (
    <>
      <NoddiDialog
        open={isDialogOpen}
        onClose={() => {
          setIsDialogOpen(false);
        }}
        title={t`Selected cars`}
      >
        <div className='flex flex-col gap-2'>
          {selectedCars.map((selectedCar) => (
            <span key={selectedCar.licensePlate.number}>
              {getCarName({ car: selectedCar, showLicensePlate: true })}
            </span>
          ))}
        </div>
      </NoddiDialog>

      <NoddiButton
        variant='outline'
        onClick={() => {
          setIsDialogOpen(true);
        }}
        startIcon='Car'
      >
        {numberOfSelectedCars} {carMessage}
      </NoddiButton>
    </>
  );
};
